import { render, staticRenderFns } from "./SlideModal.vue?vue&type=template&id=1ec94b8f"
import script from "./SlideModal.vue?vue&type=script&lang=js"
export * from "./SlideModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports